
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as compsRs5Yw6qR6C8ch_jsvZu8hXzN8T9VsxK2nnss66ars1EMeta } from "/home/runner/work/hive-ui/hive-ui/pages/comps.vue?macro=true";
import { default as index9KuVwq87LUWEwtfG1aGyBXrlDlGQzPXel59DVUMMKAIMeta } from "/home/runner/work/hive-ui/hive-ui/pages/index.vue?macro=true";
import { default as vault7dvojc3_45Ljkv2G9BXy4f66egKaCj41dC0rtJ4Uk7k5gMeta } from "/home/runner/work/hive-ui/hive-ui/pages/vault.vue?macro=true";
import { default as modalsguzCoCNCJ_QpISN1DadUFTEoVEttXh8PPTpug2a1k5EMeta } from "/home/runner/work/hive-ui/hive-ui/pages/modals.vue?macro=true";
import { default as searchp_QC2JkBQS3i5xrGJ2BGEI5acsvjy_45_45ZLBy9_GBAAvYMeta } from "/home/runner/work/hive-ui/hive-ui/pages/search.vue?macro=true";
import { default as detailsXEy1Ih8RgAPFuflbDO2_7ppgWTzkxisJc_0zyxRvFZMMeta } from "/home/runner/work/hive-ui/hive-ui/pages/details.vue?macro=true";
import { default as contacts5xZmvWRti_45_bpH9ioF3wbIQ9G2ARNhfqeaHvcsGJYSUMeta } from "/home/runner/work/hive-ui/hive-ui/pages/contacts.vue?macro=true";
import { default as settingsLLG8Vypm1_45rrnXWYDS6564Phtljcu44QXEa_457pqXeBQMeta } from "/home/runner/work/hive-ui/hive-ui/pages/settings.vue?macro=true";
import { default as dashboardoEASKepHfEO0KtqzZvk1eOFCDxzhg8JGLVLGpig_9skMeta } from "/home/runner/work/hive-ui/hive-ui/pages/dashboard.vue?macro=true";
import { default as not_45foundbe7C5B5mZinpsFleG2Ls4nXq1kODxTU1FiB7Z2xK5sYMeta } from "/home/runner/work/hive-ui/hive-ui/pages/not-found.vue?macro=true";
import { default as loginN5GUm_RH2lzdErTSMBNVGscLkuSXQi9WdZOoFeifEXwMeta } from "/home/runner/work/hive-ui/hive-ui/pages/auth/login.vue?macro=true";
import { default as radarCjl1nXC0MVpdG_DMWMUhfRYscfM5kF6lTJSgJ_45nhlvEMeta } from "/home/runner/work/hive-ui/hive-ui/pages/buzz/radar.vue?macro=true";
import { default as logoutsLqxcvZTBUAGo8U0yb8QaK1tu6flvl11BVoYuNXjeokMeta } from "/home/runner/work/hive-ui/hive-ui/pages/auth/logout.vue?macro=true";
import { default as callbackJxJppHg3Nso63D5V4IqVmYLmiRV4ZQz416Zy2hIU5d4Meta } from "/home/runner/work/hive-ui/hive-ui/pages/auth/callback.vue?macro=true";
import { default as indexJKs_45Nowfn65_45wswWE0kjGx9GH00CBGfSWzzqpF_45P_45kAMeta } from "/home/runner/work/hive-ui/hive-ui/pages/brokers/index.vue?macro=true";
import { default as contacts_45holdZtH8tZ2MMRawR3atQYl1TVQZlZeVW8NMYy2Ycj_A3TIMeta } from "/home/runner/work/hive-ui/hive-ui/pages/contacts-hold.vue?macro=true";
import { default as index75erst7eLHDUpkmN2d3FYbY0tPXwxlw2haz1OHzq83UMeta } from "/home/runner/work/hive-ui/hive-ui/pages/soc/sara/index.vue?macro=true";
import { default as risk_45chart4i1jJdkrc_45OnvHz0G_45BZP3OHHxzCHp03qQOtN_45cw_vIMeta } from "/home/runner/work/hive-ui/hive-ui/pages/buzz/risk-chart.vue?macro=true";
import { default as indexRqHWElTahGBDXs9I_D174sG2Pw_45fMcQwCKeSfXMTynoMeta } from "/home/runner/work/hive-ui/hive-ui/pages/companies/index.vue?macro=true";
import { default as indexxHdboUg2NB7i3fHvui9lUmiCrkpGuEblux2D2HR9B_EMeta } from "/home/runner/work/hive-ui/hive-ui/pages/university/index.vue?macro=true";
import { default as indexSlla258Rf8x1ZsDq8dVEkzoI3kSijUtQvylzvIAw2OMMeta } from "/home/runner/work/hive-ui/hive-ui/pages/soc/sensors/index.vue?macro=true";
import { default as indexho_TGBqEHTCWa0Ul8PzmzZRATxSazrMiXvWnOsfLqMsMeta } from "/home/runner/work/hive-ui/hive-ui/pages/business/[slug]/index.vue?macro=true";
import { default as _91tab_93oa4ikMo3GKl2wXrjV_45gTMsZDhuC0cXLUBVP3mIF1_vYMeta } from "/home/runner/work/hive-ui/hive-ui/pages/companies/[slug]/[tab].vue?macro=true";
import { default as indexcmOVWqdTRxTcEZsPPu5muriUJ_45JuRTcLpdZ5h5OaxYwMeta } from "/home/runner/work/hive-ui/hive-ui/pages/brokers/[category]/index.vue?macro=true";
import { default as indexDvi_2BRHBCYpZHNbcpg12izmSiWb3dwc_YXHuszBKkIMeta } from "/home/runner/work/hive-ui/hive-ui/pages/soc/threat_research/index.vue?macro=true";
import { default as indexEhZg_x806epemFlX5Jcs62mD_Ng4xt_WBEdzrRw8C6UMeta } from "/home/runner/work/hive-ui/hive-ui/pages/soc/incident_response/index.vue?macro=true";
import { default as indexI80L7F4KD29QgsDdqZ_TvmgMCFLm9DxD3n8BuQUd0WAMeta } from "/home/runner/work/hive-ui/hive-ui/pages/soc/critical_exposures/index.vue?macro=true";
import { default as indexygljrkAOLEiJF0_tmBUsfCzsoOG9GrAaO3dX19UnT_sMeta } from "/home/runner/work/hive-ui/hive-ui/pages/soc/signature_services/index.vue?macro=true";
import { default as _91slug_93GK0cJ6nyMK9NyOMwb0VsDmhHDOL4yZO6BitHySbOeiwMeta } from "/home/runner/work/hive-ui/hive-ui/pages/university/[module_id]/[slug].vue?macro=true";
export default [
  {
    name: "comps",
    path: "/comps",
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/comps.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/index.vue")
  },
  {
    name: "Identity Vault",
    path: "/vault",
    meta: vault7dvojc3_45Ljkv2G9BXy4f66egKaCj41dC0rtJ4Uk7k5gMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/vault.vue")
  },
  {
    name: "modals",
    path: "/modals",
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/modals.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/search.vue")
  },
  {
    name: "Exposure Details",
    path: "/details",
    meta: detailsXEy1Ih8RgAPFuflbDO2_7ppgWTzkxisJc_0zyxRvFZMMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/details.vue")
  },
  {
    name: "Trust & Family",
    path: "/contacts",
    meta: contacts5xZmvWRti_45_bpH9ioF3wbIQ9G2ARNhfqeaHvcsGJYSUMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/contacts.vue")
  },
  {
    name: "Account Settings",
    path: "/settings",
    meta: settingsLLG8Vypm1_45rrnXWYDS6564Phtljcu44QXEa_457pqXeBQMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/settings.vue")
  },
  {
    name: "Dashboard",
    path: "/dashboard",
    meta: dashboardoEASKepHfEO0KtqzZvk1eOFCDxzhg8JGLVLGpig_9skMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/dashboard.vue")
  },
  {
    name: "not-found",
    path: "/not-found",
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/not-found.vue")
  },
  {
    name: "Login",
    path: "/auth/login",
    meta: loginN5GUm_RH2lzdErTSMBNVGscLkuSXQi9WdZOoFeifEXwMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/auth/login.vue")
  },
  {
    name: "buzz-radar",
    path: "/buzz/radar",
    meta: radarCjl1nXC0MVpdG_DMWMUhfRYscfM5kF6lTJSgJ_45nhlvEMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/buzz/radar.vue")
  },
  {
    name: "Logout",
    path: "/auth/logout",
    meta: logoutsLqxcvZTBUAGo8U0yb8QaK1tu6flvl11BVoYuNXjeokMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/auth/logout.vue")
  },
  {
    name: "Logging In",
    path: "/auth/callback",
    meta: callbackJxJppHg3Nso63D5V4IqVmYLmiRV4ZQz416Zy2hIU5d4Meta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/auth/callback.vue")
  },
  {
    name: "Data Brokers",
    path: "/brokers",
    meta: indexJKs_45Nowfn65_45wswWE0kjGx9GH00CBGfSWzzqpF_45P_45kAMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/brokers/index.vue")
  },
  {
    name: "Contacts-Future",
    path: "/contacts-hold",
    meta: contacts_45holdZtH8tZ2MMRawR3atQYl1TVQZlZeVW8NMYy2Ycj_A3TIMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/contacts-hold.vue")
  },
  {
    name: "soc-sara",
    path: "/soc/sara",
    meta: index75erst7eLHDUpkmN2d3FYbY0tPXwxlw2haz1OHzq83UMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/soc/sara/index.vue")
  },
  {
    name: "buzz-risk-chart",
    path: "/buzz/risk-chart",
    meta: risk_45chart4i1jJdkrc_45OnvHz0G_45BZP3OHHxzCHp03qQOtN_45cw_vIMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/buzz/risk-chart.vue")
  },
  {
    name: "Companies",
    path: "/companies",
    meta: indexRqHWElTahGBDXs9I_D174sG2Pw_45fMcQwCKeSfXMTynoMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/companies/index.vue")
  },
  {
    name: "university",
    path: "/university",
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/university/index.vue")
  },
  {
    name: "soc-sensors",
    path: "/soc/sensors",
    meta: indexSlla258Rf8x1ZsDq8dVEkzoI3kSijUtQvylzvIAw2OMMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/soc/sensors/index.vue")
  },
  {
    name: "business-slug",
    path: "/business/:slug()",
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/business/[slug]/index.vue")
  },
  {
    name: "Company Details",
    path: "/companies/:slug/:tab?",
    meta: _91tab_93oa4ikMo3GKl2wXrjV_45gTMsZDhuC0cXLUBVP3mIF1_vYMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/companies/[slug]/[tab].vue")
  },
  {
    name: "Data Brokers - Category",
    path: "/brokers/:category()",
    meta: indexcmOVWqdTRxTcEZsPPu5muriUJ_45JuRTcLpdZ5h5OaxYwMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/brokers/[category]/index.vue")
  },
  {
    name: "soc-threat_research",
    path: "/soc/threat_research",
    meta: indexDvi_2BRHBCYpZHNbcpg12izmSiWb3dwc_YXHuszBKkIMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/soc/threat_research/index.vue")
  },
  {
    name: "soc-incident_response",
    path: "/soc/incident_response",
    meta: indexEhZg_x806epemFlX5Jcs62mD_Ng4xt_WBEdzrRw8C6UMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/soc/incident_response/index.vue")
  },
  {
    name: "soc-critical_exposures",
    path: "/soc/critical_exposures",
    meta: indexI80L7F4KD29QgsDdqZ_TvmgMCFLm9DxD3n8BuQUd0WAMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/soc/critical_exposures/index.vue")
  },
  {
    name: "soc-signature_services",
    path: "/soc/signature_services",
    meta: indexygljrkAOLEiJF0_tmBUsfCzsoOG9GrAaO3dX19UnT_sMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/soc/signature_services/index.vue")
  },
  {
    name: "university-module_id-slug",
    path: "/university/:module_id()/:slug()",
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/university/[module_id]/[slug].vue")
  }
]